import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  Modal,
  QRCode,
  Row,
  Select,
  Switch,
  Typography,
} from "antd";
import "./addAlertRuleModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";
import { GetRoleRes } from "../../interfaces/role.interface";
import { getRolesService } from "../../services/role.service";
import {
  GetAlertReceiverRes,
  NewAlertRuleReq,
} from "../../interfaces/alert.interface";
import {
  getAllAlertReceiverService,
  newAlertRuleService,
} from "../../services/alert.service";
import { getDistinctValuesService } from "../../services/event.service";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface Props {
  show: boolean;
  onClose: () => void;
}

export const AddAlertRuleModal: React.FC<Props> = (props) => {
  const health = useSelector<RootState, string>(
    (root) => root.app.health
  )
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);
  const [getOptionsLoading, setGetOptionsLoading] = useState(false);
  const [valueOptions, setValueOptions] = useState([]);

  const [alertReceivers, setAlertReceivers] = useState<GetAlertReceiverRes[]>(
    []
  );

  const [data, setData] = useState<NewAlertRuleReq>({
    active: true,
    alert_interval: "",
    condition: "",
    condition_obj: "",
    receivers_id: [],
    time_threshold: "",
    title: "",
    trigger_threshold: "",
  });

  const [filter, setFilter] = useState("");
  const [filterObjString, setFilterObjString] = useState("");
  const [filterObj, setFilterObj] = useState([
    [
      {
        parameter: "",
        action: "",
        value: "",
      },
    ],
  ]);

  useEffect(() => {
    let temp = "";
    for (let o = 0; o < filterObj.length; o++) {
      const orCondition = filterObj[o];

      let temp2 = "";
      for (let a = 0; a < orCondition.length; a++) {
        const andCondition = orCondition[a];

        if (
          andCondition.action &&
          andCondition.parameter &&
          andCondition.value
        ) {
          if (a == 0) {
            if (andCondition.parameter === "architecture") {
              if (andCondition.value == "32") {
                temp2 += `(support_32_bit ${andCondition.action} true)`;
              } else if (andCondition.value == "64") {
                temp2 += `(support_64_bit ${andCondition.action} true)`;
              }
            } else {
              temp2 += `(${andCondition.parameter} ${andCondition.action} '${andCondition.value}')`;
            }
          } else {
            if (andCondition.parameter === "architecture") {
              if (andCondition.value == "32") {
                temp2 += ` AND (support_32_bit ${andCondition.action} true)`;
              } else if (andCondition.value == "64") {
                temp2 += ` AND (support_64_bit ${andCondition.action} true)`;
              }
            } else {
              temp2 += ` AND (${andCondition.parameter} ${andCondition.action} '${andCondition.value}')`;
            }
          }
        }
      }

      if (temp2) {
        if (o == 0) {
          temp += `(${temp2})`;
        } else {
          temp += ` OR (${temp2})`;
        }
      }
      temp2 = "";
    }

    let t = "";
    if (temp == `((  ''))`) {
      t = "";
    } else {
      t = temp;
    }

    setFilter(t);

    setFilterObjString(JSON.stringify(filterObj));

    setData({
      ...data,
      condition_obj: JSON.stringify(filterObj),
      condition: t,
    });
  }, [filterObj]);

  useEffect(() => {
    setShow(props.show);
    if (props.show) {
      setFilter("");
      setFilterObjString("");
      setFilterObj([
        [
          {
            parameter: "",
            action: "",
            value: "",
          },
        ],
      ]);
      setData({
        active: true,
        alert_interval: "",
        condition: "",
        condition_obj: "",
        receivers_id: [],
        time_threshold: "",
        title: "",
        trigger_threshold: "",
      });
    }
  }, [props.show]);

  useEffect(() => {
    getALertReceiver();
  }, [health]);

  const getALertReceiver = async () => {
    try {
      if(health === 'license-false'){
        return;
      }
      const res = getAllAlertReceiverService({});
      setAlertReceivers((await res).list);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const getOptions = async (filedName: string) => {
    try {
      const temp: any = [];

      if (filedName === "architecture") {
        temp.push({
          value: 32,
          label: "۳۲ بیتی",
        });
        temp.push({
          value: 64,
          label: "۶۴ بیتی",
        });
      } else {
        const res = await getDistinctValuesService(filedName);        
        if (filedName == "event_type") {
          for (const i of res) {
            if (i != "start_app") {
              temp.push({
                value: i,
                label: i,
              });
            }
          }
        } else {
          for (const i of res) {
            temp.push({
              value: i,
              label: i,
            });
          }
        }
      }
      setValueOptions(temp);
      setGetOptionsLoading(false);
    } catch (error) {
      setGetOptionsLoading(false);
      HandleErrors(error);
    }
  };

  const submit = async () => {
    try {
      if (
        !data.title ||
        !data.condition ||
        !data.alert_interval ||
        data.receivers_id.length == 0 ||
        !data.time_threshold ||
        !data.trigger_threshold
      ) {
        toast.error("مقادیر اجباری را وارد کنید");
        return;
      }

      setLoading(true);

      const res = await newAlertRuleService(data);

      setFilter("");
      setFilterObjString("");
      setFilterObj([
        [
          {
            parameter: "",
            action: "",
            value: "",
          },
        ],
      ]);
      setData({
        active: true,
        alert_interval: "",
        condition: "",
        condition_obj: "",
        receivers_id: [],
        time_threshold: "",
        title: "",
        trigger_threshold: "",
      });
      props.onClose();
      setShow(false);
      toast.success("اطلاعات با موفقیت ثبت شد.");
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="AddAlertReceiverModal">
      <Modal
        destroyOnClose={true}
        title={"افزودن قانون جدید"}
        onCancel={() => {
          setShow(false);
          props.onClose();
          setFilter("");
          setFilterObjString("");
          setFilterObj([
            [
              {
                parameter: "",
                action: "",
                value: "",
              },
            ],
          ]);
          setData({
            active: true,
            alert_interval: "",
            condition: "",
            condition_obj: "",
            receivers_id: [],
            time_threshold: "",
            title: "",
            trigger_threshold: "",
          });
        }}
        open={show}
        footer={null}
        width={650}
      >
        <div className="AddAlertReceiverModalContent">
          <Row justify={"space-between"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>عنوان:{" "}
              </Typography.Text>
              <Input
                className="input"
                value={data.title}
                onChange={(e) => {
                  setData({
                    ...data,
                    title: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"} align={"middle"} className="input-box">
            <Col xs={24}>
              {filterObj.map((or_item, or_index) => {
                return (
                  <>
                    <Row
                      justify={"center"}
                      style={{
                        marginTop: 10,
                      }}
                    >
                      <Col
                        xs={24}
                        style={{
                          padding: "0 5px",
                        }}
                      >
                        <Card>
                          {or_item.map((and_item, and_index) => {
                            return (
                              <>
                                <Row
                                  justify={"space-between"}
                                  align={"bottom"}
                                  style={{
                                    marginBottom: 15,
                                  }}
                                >
                                  <Col xs={7}>
                                    <Typography.Text
                                      style={{
                                        fontWeight: 600,
                                      }}
                                    >
                                      <span style={{ color: "red" }}>*</span>
                                      پارامتر
                                    </Typography.Text>
                                    <Select
                                      value={and_item.parameter}
                                      size="large"
                                      variant="filled"
                                      onChange={(e) => {
                                        const temp = [...filterObj];
                                        temp[or_index][and_index].parameter = e;
                                        temp[or_index][and_index].action = "";
                                        temp[or_index][and_index].value = "";
                                        setFilterObj(temp);

                                        if (
                                          !(
                                            and_item.parameter ===
                                              "event_risk" ||
                                            and_item.parameter === "request_ip"
                                          )
                                        ) {
                                          setGetOptionsLoading(true);
                                          getOptions(e);
                                        }
                                      }}
                                      dropdownStyle={{
                                        direction: "ltr",
                                      }}
                                      style={{
                                        width: "100%",
                                        marginTop: 5,
                                      }}
                                      options={[
                                        {
                                          value: "event_type",
                                          label: "نوع رخداد",
                                        },
                                        {
                                          value: "device_manufacturer",
                                          label: "شرکت سازنده",
                                        },
                                        {
                                          value: "device_model",
                                          label: "مدل دستگاه",
                                        },
                                        {
                                          value: "package_name",
                                          label: "نام پکیج",
                                        },
                                        {
                                          value: "architecture",
                                          label: "معماری پردازنده",
                                        },
                                        {
                                          value: "app_version",
                                          label: "ورژن اپلیکیشن",
                                        },
                                        {
                                          value: "android_version",
                                          label: "ورژن اندروید",
                                        },
                                        {
                                          value: "request_ip_country_name",
                                          label: "کشور",
                                        },
                                        {
                                          value: "geo_province_fa",
                                          label: "استان",
                                        },
                                        {
                                          value: "event_risk",
                                          label: "میزان ریسک",
                                        },
                                        {
                                          value: "request_ip",
                                          label: "آدرس IP",
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col xs={7}>
                                    <Typography.Text
                                      style={{
                                        fontWeight: 600,
                                      }}
                                    >
                                      <span style={{ color: "red" }}>*</span>
                                      اپراتور
                                    </Typography.Text>
                                    <Select
                                      size="large"
                                      variant="filled"
                                      value={and_item.action}
                                      onChange={(e) => {
                                        const temp = [...filterObj];
                                        temp[or_index][and_index].action = e;
                                        setFilterObj(temp);
                                      }}
                                      style={{
                                        width: "100%",
                                        marginTop: 5,
                                      }}
                                      options={
                                        and_item.parameter == "event_risk"
                                          ? [
                                              {
                                                label: "برابر است با",
                                                value: "=",
                                              },
                                              {
                                                label: "برابر نیست با",
                                                value: "!=",
                                              },
                                              {
                                                label: "بیشتر از",
                                                value: ">",
                                              },
                                              {
                                                label: "کمتر از",
                                                value: "<",
                                              },
                                            ]
                                          : [
                                              {
                                                label: "برابر است با",
                                                value: "=",
                                              },
                                              {
                                                label: "برابر نیست با",
                                                value: "!=",
                                              },
                                            ]
                                      }
                                    />
                                  </Col>
                                  <Col xs={7}>
                                    <Typography.Text
                                      style={{
                                        fontWeight: 600,
                                      }}
                                    >
                                      <span style={{ color: "red" }}>*</span>
                                      مقدار
                                    </Typography.Text>
                                    {(and_item.parameter === "event_risk" ||
                                      and_item.parameter === "request_ip") && (
                                      <Input
                                        size="large"
                                        variant="filled"
                                        style={{
                                          marginTop: 5,
                                          direction: "ltr",
                                        }}
                                        value={and_item.value}
                                        onChange={(e) => {
                                          const temp = [...filterObj];
                                          temp[or_index][and_index].value =
                                            e.target.value;
                                          setFilterObj(temp);
                                        }}
                                        placeholder=""
                                      />
                                    )}
                                    {!(
                                      and_item.parameter === "event_risk" ||
                                      and_item.parameter === "request_ip"
                                    ) && (
                                      <Select
                                        size="large"
                                        variant="filled"
                                        value={and_item.value}
                                        onChange={(e) => {
                                          const temp = [...filterObj];
                                          temp[or_index][and_index].value = e;
                                          setFilterObj(temp);
                                        }}
                                        style={{
                                          width: "100%",
                                          marginTop: 5,
                                        }}
                                        dropdownStyle={{
                                          direction: "ltr",
                                        }}
                                        options={valueOptions}
                                      />
                                    )}
                                  </Col>
                                  <Col xs={2}>
                                    {!(and_index == 0 && or_index == 0) && (
                                      <i
                                        style={{
                                          fontSize: "1.7em",
                                          cursor: "pointer",
                                          color: "#ff3f34",
                                        }}
                                        onClick={() => {
                                          const temp = [...filterObj];
                                          temp[or_index].splice(and_index, 1);
                                          if (temp[or_index].length == 0) {
                                            temp.splice(or_index, 1);
                                          }
                                          setFilterObj(temp);
                                        }}
                                        className="las la-trash-alt"
                                      ></i>
                                    )}
                                  </Col>
                                </Row>
                                {!(and_index === or_item.length - 1) && (
                                  <Row
                                    justify={"start"}
                                    style={{
                                      marginTop: -4,
                                      marginBottom: 8,
                                    }}
                                  >
                                    <Col>
                                      <Typography.Text
                                        style={{
                                          backgroundColor: "#023fa0",
                                          color: "#fff",
                                          fontWeight: 600,
                                          padding: "5px 10px",
                                          borderRadius: 10,
                                          fontSize: "0.7em",
                                        }}
                                      >
                                        AND
                                      </Typography.Text>
                                    </Col>
                                  </Row>
                                )}
                              </>
                            );
                          })}

                          <Row
                            justify={"start"}
                            style={{
                              marginTop: 10,
                            }}
                          >
                            <Col>
                              <Button
                                block
                                onClick={() => {
                                  const temp = [...filterObj];
                                  temp[or_index].push({
                                    action: "",
                                    parameter: "",
                                    value: "",
                                  });
                                  setFilterObj(temp);
                                }}
                              >
                                <i className="las la-plus"></i>
                                AND
                              </Button>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                    {!(or_index === filterObj.length - 1) && (
                      <Row
                        justify={"start"}
                        style={{
                          marginTop: 8,
                          marginBottom: 8,
                          paddingLeft: 5,
                        }}
                      >
                        <Col>
                          <Typography.Text
                            style={{
                              backgroundColor: "#023fa0",
                              color: "#fff",
                              fontWeight: 600,
                              padding: "5px 10px",
                              borderRadius: 10,
                              fontSize: "0.7em",
                            }}
                          >
                            OR
                          </Typography.Text>
                        </Col>
                      </Row>
                    )}
                  </>
                );
              })}
              <Row
                justify={"center"}
                style={{
                  marginTop: 10,
                }}
              >
                <Col xs={3}>
                  <Button
                    block
                    onClick={() => {
                      const temp = [...filterObj];
                      temp.push([
                        {
                          action: "",
                          parameter: "",
                          value: "",
                        },
                      ]);
                      setFilterObj(temp);
                    }}
                  >
                    <i className="las la-plus"></i>
                    OR
                  </Button>
                </Col>
              </Row>
              <Divider />
            </Col>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>گیرنده:
              </Typography.Text>
              <Select
                mode="multiple"
                size="large"
                variant="filled"
                value={data.receivers_id}
                onChange={(e) => {
                  setData({
                    ...data,
                    receivers_id: e,
                  });
                }}
                style={{
                  width: "100%",
                  marginTop: 5,
                }}
                options={alertReceivers.map((i) => {
                  return {
                    value: i.id,
                    label: i.name,
                    key: i.id,
                  };
                })}
              />
            </Col>
            <Col md={7} xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>تعداد رخداد:
              </Typography.Text>
              <Input
                variant="filled"
                size="large"
                className="input"
                suffix="تعداد"
                value={data.trigger_threshold}
                onChange={(e) => {
                  setData({
                    ...data,
                    trigger_threshold: e.target.value,
                  });
                }}
              />
            </Col>
            <Col md={7} xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>بازه زمانی تعداد رخداد:
              </Typography.Text>
              <Input
                variant="filled"
                size="large"
                className="input"
                suffix="دقیقه"
                value={data.time_threshold}
                onChange={(e) => {
                  setData({
                    ...data,
                    time_threshold: e.target.value,
                  });
                }}
              />
            </Col>
            <Col md={7} xs={24} className="input-box">
              <Typography.Text className="title">
                <span style={{ color: "red" }}>*</span>بازه اطلاع رسانی:
              </Typography.Text>
              <Input
                variant="filled"
                size="large"
                className="input"
                suffix="دقیقه"
                value={data.alert_interval}
                onChange={(e) => {
                  setData({
                    ...data,
                    alert_interval: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row
            align={"middle"}
            justify={"space-between"}
            style={{
              marginTop: 20,
            }}
          >
            <Col>
              <Typography.Text className="title">وضعیت</Typography.Text>
            </Col>
            <Col>
              <Switch
                checked={data.active}
                onChange={(e) => {
                  setData({
                    ...data,
                    active: e,
                  });
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={24} className="btn-box">
              <Button
                loading={loading}
                onClick={submit}
                block
                type="primary"
                className="btn"
              >
                ثبت
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
